import React, { useState, useEffect } from 'react'
import { useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';
import { AiFillEye } from "react-icons/ai";

function Viewadmin(){
    
    const apiUrl = API_URL;
    const [items, setItems] = useState("");
    const [successMessages, setSuccessMessages] = useState([]);
    const [inputType, setInputType] = useState('password');
    const user_Id = useParams();
    const adminId = user_Id.userid;

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                userId: adminId
            };
            const res = await fetch(`${apiUrl}/admin/viewadmin`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);

    return (
        <div className='width90'>
            <h2 className='pageTitle'>View Admin</h2>
            <div className='commonCntr'>
                <form className="form-horizontal">
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="firstname">First Name:</label>
                        <div className="col-sm-4">
                            <span className='d-block'>{items.name}</span>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="lastname">Last Name:</label>
                        <div className="col-sm-4">
                            <span className='d-block'>{items.lastname}</span>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="email">Email:</label>
                        <div className="col-sm-4">
                            <span className='d-block'>{items.email}</span>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="contact">Contact Number:</label>
                        <div className="col-sm-4">
                            <span className='d-block'>{items.mobile_number}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Viewadmin;